import { render } from "./EmptyPage.vue?vue&type=template&id=411dd8be&scoped=true"
import script from "./EmptyPage.vue?vue&type=script&lang=js"
export * from "./EmptyPage.vue?vue&type=script&lang=js"

import "./EmptyPage.vue?vue&type=style&index=0&id=411dd8be&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-411dd8be"]])

export default __exports__